module.exports = __webpack_public_path__ + "static/media/project1.4087f4c8.png";